import React, { useEffect, useState } from 'react';
import SelfieModal from './SelfieModal';
import StyledModal from '../StyledModal';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import {
  deleteRequestByType,
  fetchDataRequestByType,
} from '../../actions/dataRequests';
import { SELFIE_DELETE } from '../../constants';

const SelfieDeletionModal = ({ closeModal, isOpen }) => {
  const { t } = useTranslation();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const dispatch = useDispatch();

  const dataRequests = useSelector((state) => state.dataRequests);

  const handleDeleteSelfie = () => dispatch(deleteRequestByType(SELFIE_DELETE));

  useEffect(() => {
    if (dataRequests.selfieDeleteSuccess) {
      dispatch(fetchDataRequestByType(SELFIE_DELETE));
      setIsConfirmModalOpen(false);
    }
  }, [
    dispatch,
    dataRequests.selfieDeleteSuccess,
    closeModal,
    setIsConfirmModalOpen,
  ]);

  return (
    <>
      <StyledModal
        isOpen={isOpen}
        closeModal={closeModal}
        title="Delete my selfie"
        primaryButton={{
          text: 'Delete my selfie',
          action: () => {
            closeModal();
            setIsConfirmModalOpen(true);
          },
        }}
      >
        <p>
          <Trans
            i18nKey="dataRights.selfieDelete.description_commitment"
            components={{ strong: <strong /> }}
          />
        </p>

        <p>
          <strong>Your selfie is a representation of you</strong>
          <br />
          {t('dataRights.selfieDelete.description_purpose')}
        </p>
        <p>
          <strong>What happens after selfie deletion?</strong>
          <br />
          It may take up to seven (7) days to delete your selfie and associated
          biometric data. We will confirm that we have received your request
          with the following message: “
          <i>
            We've received your request to delete your data. It may take up to 7
            days to be removed.
          </i>
          ”
        </p>
        <p>
          <strong>NOTE: Once selfie is deleted, it cannot be undone.</strong>
        </p>
      </StyledModal>
      <SelfieModal
        isOpen={isConfirmModalOpen}
        handleCancel={() => setIsConfirmModalOpen(false)}
        handleConfirm={handleDeleteSelfie}
        submitting={dataRequests.isFetching}
      />
    </>
  );
};

export default SelfieDeletionModal;
